import React from "react";
import PropTypes from "prop-types";

function TermSelection({ label, onChange, name, data = [], value }) {
  return (
    <div className="create-module__container--select">
      <select
        style={{backgroundColor:"#ddd"}}
        name={name}
        value={
          Object.keys(value).length === 0
            ? ""
            : value.term_code.concat(`-${value.open_year}`)
        }
        onChange={onChange}
        disabled={data.length === 0}
        className={data.length === 0 ? "disabled" : ""}
      >
        <option value={""}>{data.length === 0 ? "loading..." : label}</option>
        {data.map((ele) => (
          <option
            key={ele.term_code.concat(`-${ele.open_year}`)}
            value={ele.term_code.concat(`-${ele.open_year}`)}
          >
            {ele.open_year.concat(` ${ele.term_name}`)}
          </option>
        ))}
      </select>
    </div>
  );
}

TermSelection.defaultProps = {
  data: [],
};

TermSelection.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default TermSelection;
